export var getOfficeIpSuggestions = function () {
    return [
        { ipAddress: '192.168.1.100', userCount: 15 },
        { ipAddress: '10.0.0.50', userCount: 12 },
        { ipAddress: '172.16.0.25', userCount: 10 },
        { ipAddress: '192.168.1.101', userCount: 8 },
        { ipAddress: '10.0.0.51', userCount: 7 },
        { ipAddress: '172.16.0.26', userCount: 6 },
        { ipAddress: '192.168.1.102', userCount: 5 },
        { ipAddress: '10.0.0.52', userCount: 4 },
        { ipAddress: '172.16.0.27', userCount: 3 },
        { ipAddress: '192.168.1.103', userCount: 2 }
    ];
};
